// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal_4FbTh{padding:12px;color:#fff}.title_sWkDu{font-size:30px;line-height:32px;font-weight:700;margin:10px 0 32px;padding-right:40px}.point_wGiOE{margin:8px 0;color:#cfd8dc}.point__number_Pn9c2{font-weight:700;color:#ffa000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": "modal_4FbTh",
	"title": "title_sWkDu",
	"point": "point_wGiOE",
	"point__number": "point__number_Pn9c2"
};
module.exports = ___CSS_LOADER_EXPORT___;
